var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenomics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 123,
    viewBox: "0 0 121 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 5C46.5287 5 35.315 8.46029 25.7769 14.9433C16.2389 21.4263 8.80487 30.6408 4.41499 41.4217C0.0251045 52.2025 -1.12349 64.0654 1.11445 75.5103C3.3524 86.9552 8.87636 97.468 16.9878 105.719C25.0993 113.971 35.4339 119.59 46.6848 121.866C57.9357 124.143 69.5975 122.974 80.1956 118.509C90.7938 114.043 99.8521 106.481 106.225 96.7786C112.598 87.0761 116 75.6691 116 64H58L58 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54.5C113 48.5249 111.823 42.6082 109.537 37.0879C107.25 31.5676 103.898 26.5517 99.6734 22.3266C95.4483 18.1016 90.4324 14.7501 84.9121 12.4635C79.3918 10.1769 73.4751 9 67.5 9L67.5 54.5H113Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5C46.5287 5 35.315 8.46029 25.7769 14.9433C16.2389 21.4263 8.80487 30.6408 4.41499 41.4217C0.0251045 52.2025 -1.12349 64.0654 1.11445 75.5103C3.3524 86.9552 8.87636 97.468 16.9878 105.719C25.0993 113.971 35.4339 119.59 46.6848 121.866C57.9357 124.143 69.5975 122.974 80.1956 118.509C90.7938 114.043 99.8521 106.481 106.225 96.7786C112.598 87.0761 116 75.6691 116 64H58L58 5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59C121 51.252 119.5 43.5799 116.585 36.4217C113.67 29.2635 109.398 22.7594 104.012 17.2807C98.6264 11.802 92.2325 7.45613 85.1956 4.49111C78.1588 1.52608 70.6167 -3.38675e-07 63 0L63 59H121Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 54.5C113 48.5249 111.823 42.6082 109.537 37.0879C107.25 31.5676 103.898 26.5517 99.6734 22.3266C95.4483 18.1016 90.4324 14.7501 84.9121 12.4635C79.3918 10.1769 73.4751 9 67.5 9L67.5 54.5H113Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenomics);
export default __webpack_public_path__ + "static/media/Tokenomics.525e9dc84f9d858a9e67e04f7c64237f.svg";
export { ForwardRef as ReactComponent };